export const deleteUndefinedProperties = (data = {}) => {
    const output = {};
    for (const propName in data) {
        if (typeof data[propName] !== "undefined")
            output[propName] = data[propName];
    }
    return output;
};
